import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import MediaQuery from 'ha/helpers/MediaQuery';
import { H2 } from 'ha/ui/Headers';
import HubspotForm from 'ha/modules/HubspotForm';

import { HUBSPOT_PORTAL_ID } from 'ha/modules/HubspotForm/constants';

const ContactForm: React.SFC<IntlProps> = ({ intl: { T } }) => (
  <MediaQuery>
    {({ md }) => (
      <div className={cx('container-grid', md ? 'm-t-8 m-b-8' : 'm-y-5')}>
        <H2
          className={cx(
            'text-center color-black',
            md ? 'm-b-0_8 font-size-xl' : 'm-b-2',
          )}
        >
          {T('Let our Regional Specialists contact you')}
        </H2>
        <div
          className={cx(
            'text-center',
            md ? 'text-muted m-b-5 font-size-lg' : 'm-b-3',
          )}
        >
          {T("Let us contact you, we'll talk further in person")}
        </div>
        <div className="flexbox flex-justify-center">
          <HubspotForm
            portalId={HUBSPOT_PORTAL_ID}
            formId="a52d86c1-565b-45fe-bfa9-ed8849ded6a4"
            submitText={T('Contact me')}
          />
        </div>
      </div>
    )}
  </MediaQuery>
);

export default withIntl(ContactForm);
